import React from 'react';
import Iframe from 'react-iframe';

const ElementaryBlockPage = () => (
  <Iframe
    url='https://visualization.audit.samiksha.samagra.io/public/dashboard/ffde6fd4-dde7-4d27-a8df-a4b3b6e0606b'
    width='100%'
    height='100%'
    display='initial'
    position='relative'
  />
);

export default ElementaryBlockPage;
